import type { ChipContent, ScriptElement } from '../../schema';
import { textEffectAttrs } from '../text-effects';

/**
 * Chalk-warm tag pill, sized by its own text so it renders identically to the
 * editor (where the element frame hugs the pill). Authored typography
 * (size/weight/family/colour) and the highlight / long-shadow effects all win.
 */
export function ChipElement({ element }: { element: ScriptElement }) {
  const c = element.content as ChipContent | undefined;
  const fontSize = (element.style?.fontSize as number | undefined) ?? 16;
  const effects = textEffectAttrs(element.style, fontSize);
  return (
    <span
      className="inline-flex items-center whitespace-nowrap rounded-full px-3 py-1"
      style={{
        fontSize,
        fontWeight: (element.style?.fontWeight as number | undefined) ?? 500,
        fontFamily: (element.style?.fontFamily as string | undefined) ?? undefined,
        background:
          (element.style?.backgroundColor as string | undefined) ?? 'rgba(224, 137, 47, 0.16)',
        color: (element.style?.color as string | undefined) ?? '#b96b1e',
        border: '1px solid rgba(224, 137, 47, 0.4)',
        ...effects.style,
      }}
      {...(effects['data-text-hl'] != null ? { 'data-text-hl': '' } : {})}
    >
      {c?.label ?? 'Chip'}
    </span>
  );
}
